import './Pics.scss';

function Pics(props) {
return (
    <div className='pics'>
        <div className='wrapper'>
            <img  loading="lazy" alt = "" src = {props.card.img1}></img>
            <img  loading="lazy" alt = "" src = {props.card.img2}></img>
        </div>
    </div>
)}
export default Pics;